import { combineReducers, configureStore } from "@reduxjs/toolkit";

import ConfigurationSlice from "./configurationSlice";
import GeneralSlice from "./generalSlice";

export default configureStore({
  reducer: (state: any, action: any) => {
    if (action.type === "LOGOUT") {
      state = undefined;
    }
    return combineReducers({
      ConfigurationSlice,
      GeneralSlice,
    })(state, action);
  },
});
